export const isHTMLElement = (element: Element): element is HTMLElement =>
  element instanceof HTMLElement
